import { render, staticRenderFns } from "./PostImageDialog.vue?vue&type=template&id=2ba27003"
import script from "./PostImageDialog.vue?vue&type=script&lang=js"
export * from "./PostImageDialog.vue?vue&type=script&lang=js"
import style0 from "./PostImageDialog.vue?vue&type=style&index=0&id=2ba27003&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports